export enum ENTRY_TYPE {
  ORDEN_COMPRA = 'orden de compra',
  CONTRATO = 'Contrato',
  COMISO = 'Comiso',
  DONACION = 'Donación',
  COMODATO = 'Comodato',
  ACUERDO_INTERADMINISTRATIVO = 'Acuerdo interadministrativo',
  INCAUTADO_CON_FINES_DE_COMISO = 'Incautado con fines de comiso',
  ORDEN_JUDICIAL = 'Orden Judicial',
}
